//MARK: Platform errors
export const genericErrorMessage =
  "Ocorreu um erro ao salvar os dados. Tente novamente em alguns segundos.";
export const intervalGradeErrorMessage = "O valor informado deve estar entre ";

//MARK: Login/SignUp errors
export const incorrectLoginOrPasswordErrorMessage =
  "Usuário e/ou senha inválidos!";
